import request from '@/utils/request'

export function getAnnouncements (data) {
  return request({
    url: '/api/admin/announcements',
    method: 'post',
    data: data
  })
}

export function showAnnouncement (data) {
  return request({
    url: '/api/admin/announcements/show',
    method: 'post',
    data: data
  })
}

export function storeAnnouncement (data) {
  return request({
    url: '/api/admin/announcements/store',
    method: 'post',
    data: data
  })
}

export function updateAnnouncement (data) {
  return request({
    url: '/api/admin/announcements/update',
    method: 'post',
    data: data
  })
}

export function destroyAnnouncement (data) {
  return request({
    url: '/api/admin/announcements/destroy',
    method: 'post',
    data: data
  })
}

export function uploadImageCompressed (data) {
  return request({
    url: '/api/admin/upload/upload-image-compressed',
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function uploadVideoCompressed (data) {
  return request({
    url: '/api/admin/upload/upload-video-compressed',
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000
  })
}
